import * as React from "react";
import {Ticket, TicketConversation, TicketPrivateConversation} from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { TicketService } from "../../services/TicketService";
import {formatDate} from "../../util/date";

interface Props {
    ticket?: Ticket;
    note: TicketConversation | TicketPrivateConversation;
    show? : boolean;
    isReviewed?: boolean;
    canDelete? : boolean;
    deleteComment: (id: string) => void;
}
interface State {
    note: TicketConversation | TicketPrivateConversation;

}
export class TicketComp extends React.Component<Props,State> {
    service: TicketService;
    constructor(props : Props) {
        super(props);
        this.service = getContainer().getTicketService();
        this.state = { note : this.props.note};
    }

    render() {
        if (!this.props.show) {
            return <span/>
        }
        let note = this.state.note;

        return (
            <li className="clearfix">
                <div className="conversation-text">
                    <div className="ctext-wrap" style={{backgroundColor:"#e9e9e9", color:"#000000"}}>
                        <span>{note.timestamp && formatDate(Number(note.timestamp.toString().split(".").join("").substring(0,13)))}</span>
                        <div className="row">
                            <i className="col-11">{note.sender_type} - {note.sender} - {note.sender_username}</i> 
                            {this.props.isReviewed && this.props.canDelete && (
                                <div className="row" style={{marginLeft: "auto"}}>
                                    <div className="fas fa-check d-flex align-items-end flex-column col-1" title="Reviewed" />
                                    <div className="fas fa-times d-flex align-items-end flex-column col-1" onClick={()=>this.props.deleteComment(note.id!)} />
                                </div>
                            )}
                            {this.props.isReviewed && this.props.canDelete===false && (
                                <div className="fas fa-check d-flex align-items-end flex-column col-1" title="Reviewed" />
                            )}
                            {this.props.isReviewed===false && this.props.canDelete && (
                                <div className="fas fa-times d-flex align-items-end flex-column col-1" onClick={()=>this.props.deleteComment(note.id!)} />
                            )}                        
                        </div>    
                        <p >
                            {note.comment}
                        </p>
                    </div>
                </div>
            </li>
        );
    }
}

